import { makeAutoObservable, reaction, runInAction } from 'mobx';
import ssoClient from '../../infrastructure/http/ssoClient';
import { LocalStorage_keys } from '../../main/constants';
import { localStorageService } from './../../infrastructure/services/localStorageService';
import { AuthenticatedUser } from './authenticate-user';

export default class UserStore {
    token: string | null = localStorageService.get(LocalStorage_keys.JWT_KEY, false);
    user: string | null = null;
    isAuthenticated = false;
    appLoaded = false;

    constructor() {
        makeAutoObservable(this);
        reaction(
            () => this.token,
            (token) => {
                if (token) {
                    localStorageService.create(LocalStorage_keys.JWT_KEY, token);
                } else {
                    localStorageService.clear(LocalStorage_keys.JWT_KEY);
                }
            }
        );
    }

    setToken = (token: string | null) => {
        if (token) {
            this.token = token;
        }
    };

    setUser = (user: string | null) => {
        this.user = user;
    };

    setIsAuthenticated = (isAuthenticated: boolean) => {
        this.isAuthenticated = isAuthenticated;
    };

    setAppLoaded = () => {
        this.appLoaded = true;
    };

    getAuthenticatedUser = async (): Promise<string> => {
        if (!this.user) {
            await this.getUser();
            return this.user!;
        }
        return this.user;
    };

    getUser = async () => {
        try {
            ssoClient.current().then((response) => {
                console.log(response);
                runInAction(() => (this.user = response.username));
            });
        } catch (error) {
            console.log(error);
        }
    };
}
